import { create } from 'zustand';

interface UiState {
  /** 侧边栏是否折叠 */
  siderCollapsed: boolean;
  /** 主题（预留暗色切换） */
  theme: 'light' | 'dark';
  toggleSider: () => void;
  setSiderCollapsed: (collapsed: boolean) => void;
  setTheme: (theme: 'light' | 'dark') => void;
}

export const useUiStore = create<UiState>((set) => ({
  siderCollapsed: false,
  theme: 'light',
  toggleSider: () => set((s) => ({ siderCollapsed: !s.siderCollapsed })),
  setSiderCollapsed: (collapsed) => set({ siderCollapsed: collapsed }),
  setTheme: (theme) => set({ theme }),
}));
